import React from "react";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { trackPromise } from "react-promise-tracker";

import { AuthUserContext, withAuthorization } from "../../Auth/Session";

import * as constantsRetreadCatalogue from "../../../constants/actions/RetreadCatalogues";
import * as APIS from "../../../constants/apis";
import { Modal } from "react-bootstrap";

function getRetreadCatalogue(id) {
  return (dispatch) => {
    return trackPromise(
      fetch(
        `${APIS.API_REST_RETREADCATALOGUES.replace(
          "customer_id",
          localStorage.getItem("GlobalCustomerId")
        )}/${id}`,
        {
          headers: {
            Authorization: "Basic " + localStorage.getItem("firebaseAuthToken"),
            "Accept-language": localStorage.getItem("LanguageSelected"),
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          dispatch(
            getRetreadCatalogueSuccess({
              catalogue: json,
            })
          );
        })
        .catch((error) => {
          toast.success(error.message);
        })
    );
  };
}

export function getRetreadCatalogueSuccess(json) {
  return {
    type: constantsRetreadCatalogue.GET_RECATALOGUE_SUCCESS,
    json,
  };
}

class RetreadCatalogueItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      image: "",
    };
  }
  componentDidMount() {
    const id = this.props.match.params.id;
    this.props.getRetreadCatalogue(id);
  }

  openImage() {
    return (
      <Modal
        show={this.state.openModal}
        dialogClassName="modal-sm-providers"
        onHide={() => this.setState({ openModal: false })}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <img
              src={this.state.image}
              alt="example placeholder"
              style={{ width: "400px", height: "400px" }}
              className="text-center"
            />
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    );
  }

  render() {
    const { catalogue } = this.props;
    return (
      <AuthUserContext.Consumer>
        {(authUser) =>
          !!catalogue ? (
            <div className="container-fluid mt-100">
              <div className="d-flex justify-content-between">
                <h3>{this.props.t("tire-catalogue.tire-info")}</h3>
                {catalogue.image_url && (
                  <img
                    src={catalogue.image_url}
                    alt="example placeholder"
                    style={{
                      width: "200px",
                      height: "200px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      this.setState({
                        openModal: true,
                        image: catalogue.image_url,
                      })
                    }
                    className="rounded-circle text-center"
                  />
                )}
              </div>
              <br />
              <div className="text-center v-scroll">
                <table className="table table-striped table-bordered table-sm mb-0">
                  <tbody>
                    <tr>
                      <th className="w-50">
                        {this.props.t("tire-catalogue.tire-item-1")}
                      </th>
                      <td className="w-50">{catalogue.marca}</td>
                    </tr>
                    <tr>
                      <th className="w-50">
                        {this.props.t("tire-catalogue.tire-item-2")}
                      </th>
                      <td className="w-50">{catalogue.modelo}</td>
                    </tr>
                    <tr>
                      <th className="w-50">
                        {this.props.t("tire-catalogue.tire-item-3")}
                      </th>
                      <td className="w-50">{catalogue.dimention}</td>
                    </tr>
                    <tr>
                      <th className="w-50">
                        {this.props.t("tire-catalogue.tire-item-6")}
                      </th>
                      <td className="w-50">{catalogue.profundidad_original}</td>
                    </tr>
                    <tr>
                      <th className="w-50">
                        {this.props.t("tire-catalogue.tire-item-7")}
                      </th>
                      <td className="w-50">{catalogue.profundidad_minima}</td>
                    </tr>
                    <tr>
                      <th className="w-50">
                        {this.props.t("tire-catalogue.tire-item-10")}
                      </th>
                      <td className="w-50">{catalogue.precio}</td>
                    </tr>
                    <tr>
                      <th className="w-50">
                        {this.props.t("tire-catalogue.tire-item-11")}
                      </th>
                      <td className="w-50">{catalogue.distribuidor}</td>
                    </tr>
                    <tr>
                      <th className="w-50">
                        {this.props.t("tire-catalogue.tire-item-8")}
                      </th>
                      <td className="w-50">{catalogue.presion_minima}</td>
                    </tr>
                    <tr>
                      <th className="w-50">
                        {this.props.t("tire-catalogue.tire-item-9")}
                      </th>
                      <td className="w-50">{catalogue.presion_maxima}</td>
                    </tr>
                    <tr>
                      <th className="w-50">
                        {this.props.t("tire-catalogue.tire-item-12")}
                      </th>
                      <td className="w-50">{catalogue.costo_milimetraje}</td>
                    </tr>
                    <tr>
                      <th className="w-50">Ancho de banda</th>
                      <td className="w-50">{catalogue.bandwidth}</td>
                    </tr>
                    <tr>
                      <th className="w-50">Aplicación de banda/pisó</th>
                      <td className="w-50">{catalogue.band_app}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {this.state.openModal && this.openImage()}
            </div>
          ) : null
        }
      </AuthUserContext.Consumer>
    );
  }
}

const structuredSelector = createStructuredSelector({
  catalogue: (state) => state.catalogue,
});

const mapDispatchToProps = { getRetreadCatalogue };

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(
  connect(structuredSelector, mapDispatchToProps)(RetreadCatalogueItem)
);
